const INITIAL_STATE = {
    loading: false,
    message: null
}

const reducer = {
    initialState: INITIAL_STATE,
    handlers: {
    }
}

export default reducer